import { AGENT_TRACKER_ROLE } from "vue-app/types/enums";

const reviewsRoutesMeta = {
  routeName: window._trans._reviews.title,
  noPadding: true,
  skipGlobalLoader: true,
  requiredRoles: [AGENT_TRACKER_ROLE.ROLE_AGENT],
};

const hasReviewsAccess = () =>
  window.EDRONE_CONTEXT.tracker.trackerConfigurationFeatures?.HAS_ACCESS_TO_EDRONE_REVIEWS ||
  window.EDRONE_CONTEXT.user.isDev;

export const reviewsRoutes = [
  {
    path: "/app/reviews",
    name: "PageReviews",
    component: () => import("vue-app-new/pages/PageReviews/PageReviews.vue"),
    meta: reviewsRoutesMeta,
    redirect: "/app/reviews/list",
    beforeEnter: (to, from, next) => {
      if (!hasReviewsAccess()) {
        next({ path: "/app/dashboard" });
      } else {
        next();
      }
    },
    children: [
      {
        path: "list",
        name: "PageReviewsList",
        component: () => import("vue-app-new/pages/PageReviews/PageReviewsList.vue"),
        meta: reviewsRoutesMeta,
      },
      {
        path: "review-diagram",
        name: "PageReviewsReviewDiagram",
        component: () => import("vue-app-new/pages/PageReviews/PageReviewsReviewDiagram.vue"),
        meta: {
          ...reviewsRoutesMeta,
          routeName: window._trans._reviews.tabs.messages,
        },
      },
      {
        path: "reviews-widget",
        name: "PageReviewOnsiteWidget",
        component: () => import("vue-app-new/pages/PageReviews/PageReviewOnsiteWidget.vue"),
        meta: {
          ...reviewsRoutesMeta,
          routeName: window._trans._reviews.tabs.widget,
        },
      },
      {
        path: "form",
        name: "PageReviewsForm",
        component: () => import("vue-app-new/pages/PageReviews/PageReviewsForm.vue"),
        meta: {
          ...reviewsRoutesMeta,
          routeName: window._trans._reviews.tabs.form,
        },
      },
    ],
  },
];
